/* eslint-disable react-hooks/exhaustive-deps */
import Global from "../Global";
import { useState, useEffect } from "react";
import { NavLink, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Moment from "react-moment";



export default function Posts() {
  const url = Global.url;
  const [posts, setPosts] = useState([]);
  const username = useSelector((state) => state.user.username);
  const [loading, setLoading] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const [redirect, setRedirect] = useState(false);

  //fetch data from the API

  const getPosts = async () => {
    setLoadingPage(true);
    const res = await fetch(`${url}/posts`);
    const data = await res.json();
    setPosts(data.articles.reverse());
    setLoadingPage(false);
  };

  const getSubtitle = (text) => {
    for (let i = 0; i < text.length; i++) {
      if (text[i] === ".") {
        const response = text.slice(0, i) + "...";
        return response;
      }
    }
  };

  //aumentar likes

  const handleClickLike = async (id) => {
    if (!username) {
      console.log("no hay usuario");
      setRedirect(true);

    } else {
      setLoading(true);
      //preguntar los likes

      const res = await fetch(`${url}/posts/${id}`);
      const data = await res.json();

      //preguntar si ya fue likeado (pregunta si username esat en la lista del articulo)

      if (data.article.ownerLikes.includes(username)) {
        await fetch(`${url}/posts/${id}/like`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            likes: data.article.likes - 1,
          }),
        });

        await fetch(`${url}/posts/${id}/like/owner`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            //quitar username de ownerLikes
            ownerLikes: data.article.ownerLikes.filter(
              (user) => user !== username
            ),
          }),
        });
      } else {
        await fetch(`${url}/posts/${id}/like`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            likes: data.article.likes + 1,
          }),
        });

        await fetch(`${url}/posts/${id}/like/owner`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ownerLikes: [...data.article.ownerLikes, username],
          }),
        });
      }

      //actualizar los likes
      setLoading(false);

      getPosts();
    }
  };

  //redireccion a post

  useEffect(() => {
    getPosts();
  }, []);


  if (redirect) {
    return <Navigate to="/authors/null" />;
  }

  return (
    <div className="posts-container">
      {loadingPage ? (
        <div
          className="spinner-grow m-2 p-2 opacity-25"
          style={{ width: "40rem", height: "40rem", fontWeight: "900" }}
          role={"status"}
        />
      ) : (
        posts.map((post, index) => (
          <div className="mt-3 mb-1 d-flex" key={index}>
            <NavLink
              to={`/posts/${post._id}`}
              style={{ textDecoration: "none" }}
            >
              <div
                key={index}
                style={{ cursor: "pointer", width: "60vh", maxWidth: "100vw" }}
                className="card bg-dark p-5 pb-4 shadow border border-secondary"
              >


                <div className="card-header text-white mt-5">
                  <h1>{post.title}</h1>
                </div>
                <div className="card-body text-white">
                  <p>{getSubtitle(post.content)}</p>
                </div>
              </div>
            </NavLink>
            {loading ? (
              <div
                className={
                  post.ownerLikes.includes(username)
                    ? "container-likes btn-active"
                    : "container-likes"
                }
              >
                <div className="likes-count">
                  <div
                    className="spinner-border "
                    style={{ marginLeft: "1.2rem" }}
                    role={"status"}
                  />
                </div>
              </div>
            ) : (
              <div
                className={
                  post.ownerLikes.includes(username)
                    ? "container-likes btn-active"
                    : "container-likes"
                }
                onClick={() => handleClickLike(post._id)}
              >
                <button key={index} type="button" className="btn-like">
                  👍
                </button>
                <div className="likes-count">
                  <p className="p-2">{post.likes ? post.likes : 0}</p>
                </div>
                
              </div>
              
            )}
            <div className="date">
              <Moment fromNow>{post.date}</Moment>  <br /> 
              <NavLink to={`/authors/${post.author}`} style={{ textDecoration: "none" }}>
              <span>by {post.author}</span> 
              </NavLink>
            </div>
          </div>
          
        ))
      )}
    </div>
  );
}
